<div class="season-icon-container" [ngClass]="'size-' + size" *ngIf="seasonIcon">
  <img [src]="seasonIcon" [alt]="seasonAlt" class="season-icon" />
  <span *ngIf="showLabel" class="season-label">{{ seasonLabel }}</span>
</div>
<div class="season-icon-container no-season" *ngIf="!seasonIcon">
  <span class="season-label">-</span>
</div>